import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import AuthActions, { AuthTypes } from '../../appRedux/redux/Auth';
import UserActions from "../redux/User";
import {
  createUserWithEmailPasswordRequest,
  signInUserWithEmailPasswordRequest,
  signOutRequest,
  signInUserWithGoogleRequest,
  getUserFromRDB,
} from '../services/Auth'
import getFirebaseError from '../../util/getFirebaseError';


function* createUserWithEmailPassword({user}) {
  try {
    const signUpUser = yield call(createUserWithEmailPasswordRequest, user);
    if (signUpUser.message) {
      yield put(AuthActions.showAuthMessage(getFirebaseError(signUpUser.message)));
    } else {
      const userData = yield call(getUserFromRDB, signUpUser.user.uid);
      yield localStorage.setItem('user', JSON.stringify(userData));
      yield put(UserActions.setUserData(userData));
      yield put(AuthActions.hideAuthLoader());
    }
  } catch (error) {
    yield put(AuthActions.showAuthMessage(getFirebaseError(error)));
  }
}

function* signInUserWithGoogle() {
  try {
    const signUpUser = yield call(signInUserWithGoogleRequest);
    if (signUpUser.message) {
      yield put(AuthActions.showAuthMessage(getFirebaseError(signUpUser).message));
    } else {
      yield localStorage.setItem('user_id', signUpUser.user.uid);
      yield put(UserActions.setUserData(signUpUser));
      yield put(AuthActions.hideAuthLoader());
    }
  } catch (error) {
    yield put(AuthActions.showAuthMessage(getFirebaseError(error)));
  }
}

function* signInUserWithEmailPassword({user}) {
  try {
    const signInUser = yield call(signInUserWithEmailPasswordRequest, user);
    if (signInUser.message) {
      yield put(AuthActions.showAuthMessage(getFirebaseError(signInUser).message));
    } else {
      const userData = yield call(getUserFromRDB, signInUser.user.uid);
      yield localStorage.setItem('user', JSON.stringify(userData));
      yield put(AuthActions.userSignInSuccess(userData));
      yield put(UserActions.setUserData(userData));
    }
  } catch (error) {
    console.log('error: ', error);
    yield put(AuthActions.showAuthMessage(getFirebaseError(error)));
  }
}

function* signOut() {
  try {
    const signOutUser = yield call(signOutRequest);
    if (signOutUser === undefined) {
      yield localStorage.removeItem('user');
      yield put(AuthActions.userSignOutSuccess(signOutUser));
      yield put(UserActions.setUserData(null));
    } else {
      yield put(AuthActions.showAuthMessage(getFirebaseError(signOutUser.message)));
    }
  } catch (error) {
    console.log('error');
    yield put(AuthActions.showAuthMessage(getFirebaseError(error)));
  }
}

function* getUserInfo({user}) {
  try {
    yield put(AuthActions.showAuthLoader());
    const userData = yield call(getUserFromRDB, user);
    yield put(AuthActions.signInUserSuccess(userData));
    yield put(UserActions.setUserData(userData));
  } catch (error) {
    yield put(AuthActions.showAuthMessage(getFirebaseError(error)));
  }
}

export function* createUserAccountWatcher() {
  yield takeEvery(AuthTypes.USER_SIGN_UP, createUserWithEmailPassword);
}

export function* signInWithGoogleWatcher() {
  yield takeEvery(AuthTypes.USER_SIGN_IN_GOOGLE, signInUserWithGoogle);
}

export function* signInUserWatcher() {
  yield takeEvery(AuthTypes.USER_SIGN_IN, signInUserWithEmailPassword);
}

export function* signOutUserWatcher() {
  yield takeEvery(AuthTypes.USER_SIGN_OUT, signOut);
}

export function* getUserInformationWatcher() {
  yield takeEvery(AuthTypes.GET_USER_INFO, getUserInfo);
}

export default function* rootSaga() {
  yield all([
    fork(signInUserWatcher),
    fork(createUserAccountWatcher),
    fork(signInWithGoogleWatcher),
    fork(signOutUserWatcher),
    fork(getUserInformationWatcher),
  ]);
}
